import { LastPayment } from "@/types/payment";
import {
  isSmartId,
  paymentReference,
  userEmailForVerification,
  wasPaymentStatusShown,
} from "../lib/constants/session";

export const localStoragePaymentRef = {
  getItem(invoiceId: string) {
    return localStorage.getItem(`${paymentReference}:${invoiceId}`);
  },
  setItem(paymentRef: string, invoiceId: string) {
    localStorage.setItem(`${paymentReference}:${invoiceId}`, paymentRef);
  },
  removeItem(invoiceId: string) {
    localStorage.removeItem(`${paymentReference}:${invoiceId}`);
  },
  getAllItem() {
    return localStorage.getItem(`${paymentReference}:all`);
  },
  setAllItem(paymentRef: string) {
    localStorage.setItem(`${paymentReference}:all`, paymentRef);
  },
  removeAllItem() {
    localStorage.removeItem(`${paymentReference}:all`);
  },
  getLastPayment(): LastPayment | null {
    const lastPayment = localStorage.getItem("lastPayment");
    return lastPayment ? JSON.parse(lastPayment) : null;
  },
  setLastPayment(payment: LastPayment) {
    localStorage.setItem("lastPayment", JSON.stringify(payment));
  },
  removeLastPayment() {
    localStorage.removeItem("lastPayment");
  },
};

export const localStorageRegistrationSuccessIsSmartId = {
  getItem() {
    const value = localStorage.getItem(isSmartId);
    return !value ? false : JSON.parse(value);
  },
  setItem(key: boolean) {
    localStorage.setItem(isSmartId, JSON.stringify(key));
  },
  removeItem() {
    localStorage.removeItem(isSmartId);
  },
};

export const localStorageRegistrationSuccessEmail = {
  getItem() {
    const value = localStorage.getItem(userEmailForVerification);
    return !value ? "" : JSON.parse(value);
  },
  setItem(email: string) {
    localStorage.setItem(userEmailForVerification, JSON.stringify(email));
  },
  removeItem() {
    localStorage.removeItem(userEmailForVerification);
  },
};

export const localStoragePaymentStatusShown = {
  getItem(): boolean {
    const value = localStorage.getItem(wasPaymentStatusShown);
    return !value ? false : JSON.parse(value);
  },
  setItem(wasShown: boolean) {
    localStorage.setItem(wasPaymentStatusShown, JSON.stringify(wasShown));
  },
  removeItem() {
    localStorage.removeItem(wasPaymentStatusShown);
  },
};
